<script setup>
  import { ref, computed, onBeforeMount } from "vue";
  import { useCompanyStore } from "@/stores/company";
  import { useUiStore } from "@/stores/ui";
  import { useDevicesStore } from "@/stores/devices";

  const emit = defineEmits(['refresh']);
  const uiStore = useUiStore();
  const devicesStore = useDevicesStore();
  let isSubmitted = ref(false);
  let name = ref(null);
  let devicesNames = ref([]);
  let mac_address = ref(null);
  let mac_addresses = ref([]);
  const company_id = useCompanyStore().companyId;
  const getModalInfo = computed(() => uiStore.modalData);
  const getModalAction = computed(() => uiStore.modalAction);

  // const global_user_name = inject(['global_user_name']);
  const user = ref(JSON.parse(localStorage.getItem("userDetails")));

  const onSubmit = () => {
    isSubmitted.value = true;

    let data = { 
      entityId: company_id,
      kioskName : devicesNames.value,
      macAddresses : mac_addresses.value,
      userName : user.value.first_name+' '+ user.value.last_name,
      userId : user.value.user_id,
      connectionType : 'daemon',
    }
    
    devicesStore.massRestartDevice(data)
    .then(() => {
      isSubmitted.value = false;
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });
  };

  const resetStoreData = () =>{
    uiStore.resetModalStore();
  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalInfo.value.data_type == 'device' && getModalAction.value == 'restart_device'){

      name.value = getModalInfo.value.name;
      mac_address.value = getModalInfo.value.mac_address;
      devicesNames.value.push(getModalInfo.value.name);
      mac_addresses.value.push(getModalInfo.value.mac_address);

    }else if(getModalAction.value == 'mass_restart_devices') {
      if(Array.isArray(getModalInfo.value)){
        getModalInfo.value.map((row) =>{
          devicesNames.value.push(row.name)
          mac_addresses.value.push(row.mac_address)
        });
        name.value = devicesNames.value.join(", ");
      }
    }
  });
  
</script>
<template>
  <DModal v-if="['restart_device', 'mass_restart_devices'].includes(getModalAction)" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Restart Device </template>

    <template #body>
      <div class="delete-text">
        <span v-if="devicesNames.length == 1">Are you sure you want to <b>"Restart"</b> the device "{{ name }}" ?</span>
        <span v-else>Are you sure you want to <b>"Restart"</b> the devices "{{ name }}" ?</span>
      </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="isSubmitted" 
          @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">
            Restart <span v-if="isSubmitted"  class="spinner-sm" role="status" aria-hidden="true" ></span>
          </button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
        </div>
      </div>
    </template>
  </DModal>
</template>
  